import { dispatchRecordedEvent } from '../../../../utils/events';
import { SignInModalData } from './types';
import { IS_NATIVE_APP_CLIENT } from '../../../../utils/helpers';

export const OPEN_SIGN_IN_MODAL = 'OPEN SIGN IN MODAL';
export const openSignInModal = (data: SignInModalData = {}) => {
  // if is app, route to path below to trigger native sign in modal, otherwise open web sign in modal
  if (IS_NATIVE_APP_CLIENT) {
    window.location.href = '/account/login';
    return;
  }
  dispatchRecordedEvent(new CustomEvent(OPEN_SIGN_IN_MODAL, { detail: data }));
};

export const formatPhoneNumber = (val: string) => {
  const phoneNumber = val.replace(/[^\d]/g, '');
  if (phoneNumber.length < 4) return phoneNumber;
  if (phoneNumber.length < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};
export const phoneNumberFormatter = (e: React.ChangeEvent<HTMLInputElement>) => {
  const phoneNumberInput: HTMLInputElement | null = document.querySelector('#PhoneNumber');
  if (phoneNumberInput) {
    const latestChar = e.target.value[e.target.value.length - 1];
    const allowedChars = '0123456789';
    const invalidKey = latestChar && !allowedChars.includes(latestChar);
    if (invalidKey) {
      e.preventDefault();
    }
    const formattedInputValue = formatPhoneNumber(phoneNumberInput.value);
    phoneNumberInput.value = formattedInputValue;
  }
};

export const removeCountryCode = (value: string) => {
  return value.replace(/^\+[0-9]/, '');
};

export const checkIsValid = (string: string, pattern?: string) => {
  if (pattern) {
    const regex = new RegExp(pattern);
    return regex.test(string);
  }
  return true;
};
